module.exports = __webpack_public_path__ + "media/src/images/zu_exp_03-12414eda7cf41d89281b751e7a7dcb14.png";